export default {
  auth: {
    tokenCookieExpires: 1,
    tokenKey: "TOEKN",
  },
  timeout: 120000,
};
